export default "__VITE_ASSET__BqIlPntK__"